import { FC, Component, ComponentProps } from 'react'
import { Divider } from '@chakra-ui/react'

const SectionWithDivider: FC<ComponentProps<any>> = ({
  children,
  ...props
}) => {
  return (
    <>
      {children}
      <Divider my={4} {...props} />
    </>
  )
}

export default SectionWithDivider
